export const safariAgent =
  typeof window !== 'undefined' && navigator.userAgent.indexOf('Safari') > -1;
